import { z } from 'zod';

export const AbsenceSchema = z.object({
  id: z.number(),
  name: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите название' })
    .max(200, { message: 'До 200 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  shouldRemoveShift: z.boolean(),
  shortName: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите сокращенное название' })
    .max(7, { message: 'До 7 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    })
});

// Схема записи об отсутствии у сотрудника
export const PersonAbsenceSchema = z
  .object({
    personId: z.number().min(1, { message: 'Выберите сотрудника' }),
    departmentId: z.number().min(1),
    date: z.string().optional(),
    guid: z.string().optional(),
    from: z
      .string()
      .nonempty({ message: 'Укажите дату начала' })
      .refine((val) => !isNaN(Date.parse(val)), {
        message: 'Неверный формат даты начала'
      }),
    to: z
      .string()
      .nonempty({ message: 'Укажите дату окончания' })
      .refine((val) => !isNaN(Date.parse(val)), {
        message: 'Неверный формат даты окончания'
      }),
    absence: z.object({
      id: z.number().min(1, { message: 'Выберите вид отсутствия' }),
      label: z.string().optional(),
      shortName: z.string().optional(),
      shouldRemoveShift: z.boolean()
    })
  })
  .refine((data) => new Date(data.from) < new Date(data.to), {
    path: ['from'],
    message: 'Дата начала должна быть раньше даты окончания'
  });
